import styled from "styled-components";

import { Tabs } from "@libraries/mui/components";

import { windowWidth } from "@styles/global";

const PageTabsContainer = styled(Tabs)`
  
  .MuiTabs-scrollButtons.Mui-disabled {
    opacity: 0.3;
  }

  .MuiTabs-scroller {
    .MuiTabs-flexContainer {
      gap: 5px !important;

      > :not(.Mui-selected) {
        * {
          opacity: 65%;
        }
      }
    }
  
    .MuiTabs-indicator {
      background-color: ${(props) => props.theme.colors.primary};
      border-radius: 50px;
      height: 5px;
      padding: 0 10px !important;

      @media ( max-width: ${windowWidth.laptop.large} ) {
        height: 4px;
      }

    }
  }
`;

export { PageTabsContainer };
